<script lang="ts">
import NavBar from './components/NavBar.vue'
import SideBar from './components/SideBar.vue'

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',

  components: {
    NavBar,
    SideBar
  },

  data() {
    return {
      sidebarOpen: false
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen
    },
    closeSidebar() {
      this.sidebarOpen = false
    }
  }
})
</script>

<template>
  <div class="flex h-screen bg-gray-50 overflow-hidden">
    <SideBar :isOpen="sidebarOpen" @close="closeSidebar" />

    <div class="flex flex-col flex-1 min-w-0 px-4">
      <NavBar @toggleSidebar="toggleSidebar" />

      <main class="flex-1 overflow-auto py-4 mt-6 border-t border-gray-100">
        <router-view />
      </main>
    </div>
  </div>
</template>
